import { benefits } from '@/mocks/categories';

export default function Benefits() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1100px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-semibold text-foreground-900 mb-3">
            Why Thousands Of Users Search For Kakobuy Spreadsheet
          </h2>
          <p className="text-sm text-foreground-600 max-w-[600px] mx-auto">
            Discover why organized product spreadsheets have become an essential tool for smart shoppers worldwide
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {benefits.map((benefit) => (
            <div
              key={benefit.title}
              className="group p-6 rounded-lg bg-background-50 border border-background-200/60 hover:border-primary-200 transition-all"
            >
              <div className="w-11 h-11 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 mb-4 group-hover:bg-primary-200 transition-colors">
                <i className={`${benefit.icon} text-xl`}></i>
              </div>
              <h3 className="font-semibold text-foreground-900 text-sm mb-2">{benefit.title}</h3>
              <p className="text-xs text-foreground-600 leading-relaxed">{benefit.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}